export const state = {
  filters: {
    id: {
      value: null,
      modifiers: null,
      title: 'ID',
      type: 'input'
    },
    name: {
      value: null,
      modifiers: {
        matchType: 'contains'
      },
      title: 'Login',
      type: 'input'
    },
    billingName: {
      value: null,
      modifiers: {
        matchType: 'contains'
      },
      title: 'Company',
      type: 'input'
    },
    manager: {
      title: 'Manager',
      type: 'select',
      multiple: false,
      optionLabelKey: 'label',
      trackByKey: 'id',
      value: null
    }
  },
  orderBy: []
}
